/**
 * App Component
 *
 * Root application component with providers
 */

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { SettingsPage } from './pages/SettingsPage';
import { AdminSettingsPage } from './pages/AdminSettingsPage';
import { TestArtifactSelection } from './pages/TestArtifactSelection';
import { UserGate } from './components/user/UserGate';
import { SystemGate } from './components/system/SystemGate';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1
    }
  }
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <UserGate>
          <SystemGate>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/admin/settings" element={<AdminSettingsPage />} />
              <Route path="/test-artifact-selection" element={<TestArtifactSelection />} />
            </Routes>
          </SystemGate>
        </UserGate>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
